import { useQuery } from "@tanstack/react-query";
import { getList } from "lib/http";

export interface ProductSupplier {
  id: number;
  name: string;
}
function fetchProductSuppliers() {
  return getList<ProductSupplier>("product/suppliers");
}

export const useProductSuppliers = () => {
  return useQuery(["product-suppliers"], () => fetchProductSuppliers(), { keepPreviousData: true });
};
